import css from './DisplayContents.less'
import {withClass} from '../helpers/react-helpers'

const DisplayContents = withClass('div',css.style)
export default DisplayContents
